import React, { useState, useEffect } from "react";
import img from "./Img/bonenail.png";

export default function NailFeature() {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
            window.matchMedia("(min-width: 1280px)").matches
          );
           useEffect(() => {
              const mediaQuery = window.matchMedia("(min-width: 1280px)");
              const handleChange = (e) => setIsLargeScreen(e.matches);
              mediaQuery.addEventListener("change", handleChange);
          
              return () => {
                mediaQuery.removeEventListener("change", handleChange);
              };
            }, []);
  return (
    <>{isLargeScreen&&
      <div className=" w-100 uh-144 d-flex justify-content-center  ">
      <div className="m-0 p-0 d-flex bg-gray-light align-items-center w-75 uh-120  br-5 box-shadow ">
          <div className="uh-120 uw-50 "
           style={{
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderTopLeftRadius: "calc(var(--unit) * 5) !important",
          borderBottomLeftRadius: "calc(var(--unit) * 5) !important",
          overflow: "hidden",
          }}></div>
          <div className="uh-120 uw-20"></div>
          <div className="m-0 p-0 uw-140 "><p className="m-0 upy-2 ufs-6 fw-bold text-blue">
          Next-Gen Fully Implantable Bone Lengthening System</p>
  
          <p className="m-0 p-0 ufs-4 fw-bold">
          Precision-Controlled. Minimally Invasive. Tailored for Indian Patients.
          We're introducing a breakthrough in limb lengthening technology — a fully implantable bone distraction nail engineered for precision, safety, and patient comfort.
          This advanced system allows non-invasive control of limb lengthening through an External Remote Controller (ERC)
          placed outside the body, delivering 1 mm/day distraction with unmatched consistency.
          Built on the principle of distraction osteogenesis, our system promotes natural bone
          regeneration through gradual mechanical stretching. By eliminating the need for external fixators, our implant significantly 
          reduces risks of pin-site infections and minimizes scarring — a major leap forward in orthopedic care.
          </p>
       </div>
      </div> 
    </div>
    }
    {!isLargeScreen&&
      <div className=" d-flex justify-content-center w-100  my-5 ">
      <div className="m-0 p-0 d-flex bg-gray-light align-items-center w-100  br-5 box-shadow ">
          <div className="uh-250 w-25 "
           style={{
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderTopLeftRadius: "calc(var(--unit) * 5) !important",
          borderBottomLeftRadius: "calc(var(--unit) * 5) !important",
          overflow: "hidden",
          }}></div>
         
          <div className="m-0 px-4 w-100 "><p className="m-0 upy-2 ufs-9 fw-bold text-blue">
          Next-Gen Fully Implantable Bone Lengthening System</p>
  
          <p className="m-0 p-0 ufs-8 fw-bold">
          Precision-Controlled. Minimally Invasive. Tailored for Indian Patients.
          We're introducing a breakthrough in limb lengthening technology — a fully implantable bone distraction nail engineered for precision, safety, and patient comfort.
          This advanced system allows non-invasive control of limb lengthening through an External Remote Controller (ERC)
          placed outside the body, delivering 1 mm/day distraction with unmatched consistency.
          Built on the principle of distraction osteogenesis, our system promotes natural bone
          regeneration through gradual mechanical stretching. By eliminating the need for external fixators, our implant significantly 
          reduces risks of pin-site infections and minimizes scarring — a major leap forward in orthopedic care.
          </p>
      </div>
      </div>
    
  </div>
    }</>
    
  )
} 
